// extracted by mini-css-extract-plugin
export default {"price":"T6-z","onSale":"U6-z","msrpLabelPrice":"V6-z","msrpLabel":"W6-z","originalPrice":"X6-z","percentOff":"Y6-z"};